import { createCrudActions } from '../utils/crudGenerator';

const formatHistorics = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchHistorics,
    create: createHistoric,
    update: updateHistoric,
    delete: deleteHistorics
} = createCrudActions('HISTORIC', "Historico", formatHistorics);